import { Box, Grid, Link, PageContainer, Typography, colorsPalette, styled } from '@lingoda/ui';
import { createDate } from '@lingoda/dates';
import { imprintPath, privacyPath, termsPath } from '@lingoda/router';
import { trans } from '@lingoda/i18n';

export const LightFooter = () => {
    const currentYear = createDate().getFullYear();

    return (
        <Footer>
            <PageContainer>
                <Grid container alignItems="center" spacing={4}>
                    <Grid item xs={12} md={6}>
                        <Copyright>© {currentYear} Lingoda GmbH</Copyright>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Grid
                            container
                            justify="center"
                            spacing={2}
                            sx={{ color: colorsPalette.whiteSolid[100] }}
                        >
                            <Grid item>
                                <Link color="inherit" to={imprintPath()}>
                                    {trans('footer.other-links.imprint', {}, 'public-common')}
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="inherit" to={privacyPath()}>
                                    {trans('footer.lingoda.privacy', {}, 'public-common')}
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="inherit" to={termsPath()}>
                                    {trans('footer.lingoda.terms', {}, 'public-common')}
                                </Link>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </PageContainer>
        </Footer>
    );
};

const Footer = styled(Box)(({ theme }) => ({
    background: colorsPalette.primarySolid[100],
    position: 'relative',
    padding: theme.spacing(5),
    color: colorsPalette.whiteSolid[100],
}));

const Copyright = styled(Typography)(({ theme }) => ({
    color: 'inherit',
    [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
    },
}));
